import React from 'react';
import { T } from 'shared/helper/translate';
import Link from 'shared/components/Link';
import DigitalEditResults from './DigitalEditResults';
import SubmitDigitalEditForm from './SubmitDigitalEditForm';
var ManageDigitalEdits = function ManageDigitalEdits(_ref) {
  var archiveDigitalEdit = _ref.archiveDigitalEdit,
    digitalEditEnabled = _ref.digitalEditEnabled,
    digitalEdits = _ref.digitalEdits,
    createDigitalEdit = _ref.createDigitalEdit,
    digitalEditingTrialEnabled = _ref.digitalEditingTrialEnabled,
    getDownloadUrl = _ref.getDownloadUrl,
    pagination = _ref.pagination,
    paginationUrl = _ref.paginationUrl,
    pathname = _ref.pathname,
    searchDigitalEdits = _ref.searchDigitalEdits,
    status = _ref.status,
    updateDisplayedDigitalEdits = _ref.updateDisplayedDigitalEdits,
    uuid = _ref.uuid;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("h3", null, /*#__PURE__*/React.createElement(T, {
    source: "Your digital edits"
  })), digitalEditEnabled || digitalEditingTrialEnabled ? /*#__PURE__*/React.createElement(SubmitDigitalEditForm, {
    createDigitalEdit: createDigitalEdit,
    uuid: uuid
  }) : /*#__PURE__*/React.createElement("div", {
    className: "digital-editing-upload-disabled alert alert-warning clearfix mt-2"
  }, /*#__PURE__*/React.createElement(Link, {
    to: "/researcher/digital-editing/subscribe",
    className: "btn btn-primary float-end ms-1"
  }, /*#__PURE__*/React.createElement(T, {
    source: "Subscribe"
  })), /*#__PURE__*/React.createElement(T, {
    source: "digital-editing-resubscribe-notice"
  })), digitalEdits.length > 0 ? /*#__PURE__*/React.createElement(DigitalEditResults, {
    archiveDigitalEdit: archiveDigitalEdit,
    digitalEdits: digitalEdits,
    getDownloadUrl: getDownloadUrl,
    pagination: pagination,
    paginationUrl: paginationUrl,
    pathname: pathname,
    searchDigitalEdits: searchDigitalEdits,
    status: status,
    updateDisplayedDigitalEdits: updateDisplayedDigitalEdits
  }) : /*#__PURE__*/React.createElement("div", {
    className: "no-results bg-light border mt-3 p-5 text-secondary text-center text-small"
  }, /*#__PURE__*/React.createElement(T, {
    source: "Your completed Digital Edits will appear here"
  })));
};
export default ManageDigitalEdits;